var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 53,
    viewBox: "0 0 78 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0769 4.72222V7.44444M56.0769 18.3333V21.0556M56.0769 31.9444V34.6667M56.0769 45.5556V48.2778M21.9231 29.2222H41.8462M21.9231 37.3889H33.3077M6.26923 2C3.91262 2 2 3.82933 2 6.08333V17.0666C3.73329 18.0211 5.17299 19.3956 6.17405 21.0517C7.17511 22.7078 7.70219 24.587 7.70219 26.5C7.70219 28.413 7.17511 30.2922 6.17405 31.9483C5.17299 33.6044 3.73329 34.9789 2 35.9334V46.9167C2 49.1707 3.91262 51 6.26923 51H71.7308C74.0874 51 76 49.1707 76 46.9167V35.9334C74.2667 34.9789 72.827 33.6044 71.826 31.9483C70.8249 30.2922 70.2978 28.413 70.2978 26.5C70.2978 24.587 70.8249 22.7078 71.826 21.0517C72.827 19.3956 74.2667 18.0211 76 17.0666V6.08333C76 3.82933 74.0874 2 71.7308 2H6.26923Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.5bbd47d5cd9c3cbdefc463f4b0dad70f.svg";
export { ForwardRef as ReactComponent };